﻿if (!String.prototype.endsWith)
    String.prototype.endsWith = function (searchStr, Position) {
        // This works much better than >= because
        // it compensates for NaN:
        if (!(Position < this.length))
            Position = this.length;
        else
            Position |= 0; // round position
        return this.substr(Position - searchStr.length,
                           searchStr.length) === searchStr;
    };

module.exports = function ($, mustache, urlParameters, addToGlossary, removeFromGlossary) {
    return {
        results: null,
        init: function () {
            var isValidPage = $("body:first").hasClass("glossaryUpgrade");
            if (isValidPage) {
                this.initForm();
                this.initExport();
                var $searchFilters = $('.glossaryUpgrade__filters'),
                    $searchFilterClose = $searchFilters.find('a.small-close'),
                    $smallScreenFilterToggle = $('.glossaryUpgrade__filterToggle').find('a'),
                    $filterActiveStateTarget = $('body');

                // small screen device filter toggle
                $smallScreenFilterToggle.on('click touch', function ($event) {

                    $('.container').css({ overflow: 'inherit' });

                    $event.preventDefault();
                    $filterActiveStateTarget.addClass('search-filters-active');
                    $('html, body').animate({
                        scrollTop: 0
                    }, 500);
                });

                $searchFilterClose.on('click touch', function ($event) {

                    $('.container').css({ overflow: 'hidden' });

                    $event.preventDefault();
                    $filterActiveStateTarget.removeClass('search-filters-active');
                });
            }
        },
        initForm: function () {
            var self = this; // Used to reference 'this' inside anonymous functions (e.g. click events)
            var keywords = urlParameters.param('keywords');
            var categories = urlParameters.param('categories');
            var alpha = urlParameters.param('alpha');
            var page = urlParameters.param('page') || 1;
            var resultsPerPage = urlParameters.param('results') || 50;
            var ordering = urlParameters.param('order') || "AZ";
            var glossaryId = urlParameters.param('glossaryId');
            var wordOfTheDayId = urlParameters.param('wordOfTheDayId');

            // Set the initial form values
            $('#keywords').val(keywords);

            $('#memberGlossaryId').val(glossaryId);

            $('#wordOfTheDayId').val(wordOfTheDayId)

            $('.resourceSearch__searchTerms').text(keywords);

            $('#resultsOrder').val(ordering);

            $(".glossaryUpgrade__results__paging__alpha li:first").addClass("alpha-active");
            if (alpha != null && alpha.toLowerCase() !== "") {
                $('.glossaryUpgrade__results__paging__alpha li').removeClass("alpha-active");
                $(".glossaryUpgrade__results__paging__alpha li:contains(\"" + alpha.toUpperCase() + "\")").not(".ignore-this-alpha").addClass("alpha-active");
            }

            $('#page').val(page);
            $('#resultsPerPage').val(resultsPerPage);

            // Create year selection events.
            $('.glossaryUpgrade__filters__keyword__search__button').on("click", function (e) {
                e.preventDefault();

                // Reset the page number to 1
                $('#page').val(1);
                //if (e.keyCode == '13') {
                //    $('body').removeClass('search-pagings-active');
                //}

                $('body').removeClass('search-filters-active');
                $('.glossaryUpgrade__results__paging__alpha li').removeClass("alpha-active");

                // Update the you searched label
                //$('.resourceSearch__searchTerms').text($("#keywords").val());
                // Get new results
                $('#wordOfTheDayId').val('');
                urlParameters.param('wordOfTheDayId', '');

                self.search();
            });

            $("#keywords").on("keyup",
                function (e) {
                    if (e.keyCode === 13) {
                        $('.glossaryUpgrade__filters__keyword__search__button').trigger("click");
                    }
                });

            $('.glossaryUpgrade__results__paging #resultsOrder').change(function () {
                // Reset the page number to 1
                $('#page').val(1);
                // Get new results
                self.search(0);
            });


            $('.glossaryUpgrade__results__paging #resultsPerPage').change(function () {
                // Reset the page number to 1
                $('#page').val(1);
                // Get new results
                self.search(0);
            });

            // Create cat selection events
            $('.glossaryUpgrade__results__paging__alpha li').click(function () {
                $('.glossaryUpgrade__results__paging__alpha li').removeClass("alpha-active");
                $(this).addClass("alpha-active");
                if ($(this).text == 'All') {
                    $('#wordOfTheDayId').val('');
                    urlParameters.param('wordOfTheDayId', '');
                }
                    
                $('#keywords').val("");
                // Reset the page number to 1
                $('#page').val(1);
                // Get new results
                self.search(0);
            });

            // Set the click events on the previous and next buttons
            $('.glossaryUpgrade__results__pagination .prev').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var page = parseInt($('#page').val()) - 1;
                if (page > 0) {
                    $('#page').val(page);
                    self.search();
                }
            });

            $('.glossaryUpgrade__results__pagination .next').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var page = parseInt($('#page').val()) + 1;
                if (page <= $('#pagination').data('pages')) {
                    $('#page').val(page);
                    self.search();
                }
            });

            this.populateFilters();

            // On first load get results.
            if (wordOfTheDayId !== null) {
                this.search();
            }
            else
                this.search(0);

            // Listen for back events that don't trigger a reload and force a reload
            window.addEventListener('popstate', function(e) {
                //alert('here');
                //self.initForm();
            });

            $('#select-all').click(function (e) {
                $('input:checkbox[id^="checkbox-term-"]').prop('checked', $('#select-all').is(':checked'));
            });

            $("#glossary-search-reset").click(function () {
                $("#keywords").val("");

                // reset the id 
                $('#wordOfTheDayId').val('');
                $('#startyear')[0].selectedIndex = 0;
                $('#endyear')[0].selectedIndex = 0;

                $('input:checkbox[id$="_status"]').prop('checked', false);
                $('input:checkbox[id^="source-"]').prop('checked', false);
                $('#glossary-categories').val(null).trigger("change");
                $('#glossary-category-selection li').removeClass("active")
                $("#selectedCategories").val(null);

				$(".glossaryUpgrade__results__paging__alpha li").removeClass("alpha-active");
                $(".glossaryUpgrade__results__paging__alpha li:first").addClass("alpha-active");

                // reset and do a blank search
                self.search(0);
            });

            $(".filters-expand-collapse").click(function () {

                if ($(this).parent().parent().find('.filter-list').is(':hidden')) {
                    $(this).css('background-image', 'url(/assets/images/icons/retina/upArrow.png)');
                }
                else {
                    $(this).css('background-image', 'url(/assets/images/icons/retina/downArrow.png)');
                }

                $(this).parent().parent().find('.filter-list').slideToggle();
            });
        },
        initExport: function () {

            var self = this;

            var fileName = "";

            $('.export-selected').on('click', function (e) {
                e.preventDefault();
                $('.export-valid-message').hide();
                var target = $(e.target)

                var ids = [];
                $('.glossaryUpgrade__results__list__item input[type="checkbox"]').each(function (i) {
                    if ($(this).is(":checked"))
                        ids.push($(this).parents('.glossaryUpgrade__results__list__item').attr('data-term-id'));
                });

                // if none checked.
                if (ids.length == 0)
                {
                    $('.export-valid-message').show();
                    return;
                }

                self.showExportSpinner(target);

                // Export all on current page.
                $.ajax({
                    url: '/umbraco/Api/glossaryapi/searchexport',
                    type: 'POST',
                    data: {
                        termIds: ids.toString(),
                        isPdfExport: $('#checkbox-export-pdf').is(':checked') ? true : false
                    },
                    cache: false,
                    success: function (url) {
                        if (url.endsWith('.pdf'))
                            window.open(url, '_blank'); // should open pdf in new window based on browser settings.
                        else
                            window.location.href = url; // should kick off a download of CSV
                    },
                    error: function () {
                        console.log("An error occurred when exporting.");
                    },
                    complete: function () {
                        self.hideExportSpinner(target);
                    }
                });
            });
            
            $('.export-all').on('click', function (e) {
                e.preventDefault();
                var target = $(e.target)
                
                var exportUrl = "/umbraco/Api/glossaryapi/searchexportall";
                // Check if this is a glossary search
                if ($('#memberGlossaryId').val() !== "") {
                    exportUrl = "/umbraco/Api/glossaryapi/searchexportallmember";
                }

                // Get the alpha
                var alpha = new Array();
                $.each($(".glossaryUpgrade__results__paging__alpha li.alpha-active").not(".ignore-this-alpha"), function () {
                    alpha.push($(this).html());
                });

                // Get the multi select values.
                var sources = $.map($('input[name="source"]:checked'), function (c) { return c.value; });
                var status = $.map($('input[name="status"]:checked'), function (c) { return c.value; });
                var categories = $("#selectedCategories").val().split(',').filter(function (e) { return e; });
                var wordOfTheDayId = $('#wordOfTheDayId').val();
                var startYear = $('#startyear').val();
                var endYear = $('#endyear').val();

                self.showExportSpinner(target);

                // Export all.
                $.ajax({
                    url: exportUrl,
                    type: 'POST',
                    traditional: true,
                    data: {
                        keywords: $('#keywords').val(),
                        categories: categories,
                        statuses: status,
                        sources: sources,
                        order: $("#resultsOrder").val(),
                        alpha: alpha,
                        memberGlossaryId: $('#memberGlossaryId').val(),
                        isPdfExport: $('#checkbox-export-pdf').is(':checked') ? true : false,
                        wordOfTheDayId: wordOfTheDayId,
                        startYear: startYear > endYear ? endYear : startYear,
                        endYear: startYear > endYear ? startYear : endYear
                    },
                    success: function (url) {
                        if (url.endsWith('.pdf'))
                            window.open(url, '_blank'); // should open pdf in new window based on browser settings.
                        else
                            window.location.href = url; // should kick off a download of CSV
                    },
                    error: function () {
                        console.log("An error occurred when exporting.");
                    },
                    complete: function () {
                        self.hideExportSpinner(target);
                    }
                });
            });
        },
        showExportSpinner: function(src){
            src.parent().find('.export-spinner').fadeIn();
        },
        hideExportSpinner: function (src) {
            src.parent().find('.export-spinner').fadeOut();
        },
        populateFilters: function () {

            // Perform ajax sources search
            $.ajax({
                url: '/umbraco/Api/glossaryapi/sources',
                type: 'GET',
                traditional: true,
                context: this,
                success: function (results) {

                    // Load the results
                    var sources = $('#sourcesList');
                    sources.empty();
                    var template = $('.glossaryUpgrade__filters__source > script').html();
                    mustache.parse(template);
                    var rendered = mustache.render(template, { items: results });
                    sources.html(rendered);

                },
                error: function () {
                    //console.log("An error occurred when searching.");
                }
            });

            // Perform ajax categories search
            $.ajax({
                url: '/umbraco/Api/glossaryapi/categories',
                type: 'GET',
                traditional: true,
                context: this,
                success: function (results) {

                    // Load the results
                    var categoriesSelectList = $('#categoriesSelectList');
                    categoriesSelectList.empty();
                    var categoriesSelectListTemplate = $('.glossaryUpgrade__filters__category__item > script').html();
                    mustache.parse(categoriesSelectListTemplate);
                    var categoriesSelectListRendered = mustache.render(categoriesSelectListTemplate, { items: results });
                    categoriesSelectList.html(categoriesSelectListRendered);

                    var categoriesList = $('#categoriesList');
                    categoriesList.empty();
                    var categoriesListTemplate = $('.glossaryUpgrade__filters__category__list > script').html();
                    mustache.parse(categoriesListTemplate);
                    var categoriesListRendered = mustache.render(categoriesListTemplate, { items: results });
                    categoriesList.html(categoriesListRendered);

                    $('#glossary-categories').on("select2:select", function (e) {
                        var value = e.params.data.id;
                        $('#glossary-category-selection ul li a[data-value=' + value + ']').addClass("active").parent().addClass('active'); // need to add class to parent also for css.
                        var currentCategories = $("#selectedCategories").val();
                        var categories = currentCategories.split(",").filter(function (e) { return e; });
                        currentCategories = currentCategories + "," + value;
                    });

                    $('#glossary-categories').on("select2:unselect", function (e) {
                        var value = e.params.data.id;
                        $('#glossary-category-selection ul li a[data-value=' + value + ']').removeClass("active").parent().removeClass('active'); // need to add class to parent also for css.
                        var currentCategories = $("#selectedCategories").val();
                        var categories = currentCategories.split(",").filter(function (e) { return e; });
                        currentCategories = currentCategories.replace("," + value, "");
                    });

                    $("#glossary-category-selection li a").click(function () {

                        var value = $(this).attr("data-value");

                        var currentCategories = $("#selectedCategories").val();
                        var categories = currentCategories.split(",").filter(function (e) { return e; });
                        if ($(this).hasClass("active")) {
                            currentCategories = currentCategories.replace("," + value, "");
                            $(this).removeClass("active").parent().removeClass('active');
                            $('#glossary-categories option[value=' + value + ']').prop('selected', false)
                        }
                        else {
                            currentCategories = currentCategories + "," + value;
                            $(this).addClass("active").parent().addClass('active');
                            $('#glossary-categories option[value=' + value + ']').prop('selected', true)
                        }
                        $('#glossary-categories').trigger('change.select2');

                        // Set new categories string
                        $("#selectedCategories").val(currentCategories.replace(",,", ","));

                    });

                    // set select2 config settings
                    var settings = {
                        allowClear: false,
                        width: '100%'
                    }

                    $('#glossary-categories').select2(settings);

					$('[data-toggle="popover"]').popover();

					$('[data-toggle="popover"]').on('click', function (e) {
						$('[data-toggle="popover"]').not(this).popover('hide');
					});
                },
                error: function () {
                    //console.log("An error occurred when searching.");
                }
            });

        },
        search: function (scrollOption) {
            // Get the alpha
            var alpha = new Array();
            $.each($(".glossaryUpgrade__results__paging__alpha li.alpha-active").not(".ignore-this-alpha"), function () {
                alpha.push($(this).html());
            });

            // Get the multi select values.
            var sources = $.map($('input[name="source"]:checked'), function (c) { return c.value; });
            var status = $.map($('input[name="status"]:checked'), function (c) { return c.value; });
            var categories = $("#selectedCategories").val().split(',').filter(function (e) { return e; });
            var wordOfTheDayId = $('#wordOfTheDayId').val();
            var startYear = $('#startyear').val();
            var endYear = $('#endyear').val();

            // reset the id 
            $('#wordOfTheDayId').val('');
            urlParameters.addParam('wordOfTheDayId', '');

            // Update the URL with the parameters
            urlParameters.addParam('keywords', $("#keywords").val());
            urlParameters.addParam('alpha', alpha.length == 1 ? alpha[0].toString() : "");
            urlParameters.addParam('page', $("#page").val());
            urlParameters.addParam('results', $("#resultsPerPage").val());
            urlParameters.addParam('order', $("#resultsOrder").val());

            var searchUrl = "/umbraco/Api/glossaryapi/searchupgrade";
            // Check if this is a glossary search
            if ($('#memberGlossaryId').val() !== "") {
                searchUrl = "/umbraco/Api/glossaryapi/searchupgrademember";
            }

            // Perform and ajax search
            $.ajax({
                url: searchUrl,
                type: 'POST',
                traditional: true,
                data: {
                    keywords: $('#keywords').val(),
                    skip: ($("#page").val() - 1) * $("#resultsPerPage").val(),
                    take: $("#resultsPerPage").val(),
                    categories: categories,
                    statuses: status,
                    sources: sources,
                    order: $("#resultsOrder").val(),
                    alpha: alpha,
                    memberGlossaryId: $('#memberGlossaryId').val(),
                    wordOfTheDayId: wordOfTheDayId,
                    startYear: startYear > endYear ? endYear : startYear,
                    endYear: startYear > endYear ? startYear : endYear
                },
                context: this,
                success: function (jsonData) {
                    this.displayResults(jsonData, scrollOption);
                },
                error: function () {
                    //console.log("An error occurred when searching.");
                }
            });
        },
        displayResults: function (jsonData, scrollOption) {
            var self = this; // Used to reference 'this' inside anonymous functions (e.g. click events)

            //// Reformat the dates
            //jsonData.results.forEach(function (result) {
            //    result.lastUpdated = new Date(result.lastUpdated).toISOString().replace(/^(\d*)-(\d*)-(\d*).*$/, '$3/$2/$1');
            //});

            //// Load up the category counts.
            //for (var category in jsonData.categoryCounts) {
            //    if (!jsonData.categoryCounts.hasOwnProperty(category))
            //        continue;

            //    // set the count.
            //    $('#cat-count-' + category).text(jsonData.categoryCounts[category]);
            //}

            // Load the results
            var results = $('#resultsList');
            results.empty();

            $('#select-all').prop('checked', false);

            var template = $('.glossaryUpgrade__results > script').html();
            mustache.parse(template);
            var rendered = mustache.render(template, { items: jsonData.results });
            results.html(rendered);

            // Set the result counts
            if (jsonData.count > 0 && jsonData.skip < jsonData.count) {
                var resultsStart = jsonData.skip + 1;
                var resultsEnd = jsonData.skip + jsonData.results.length;
                $('.glossaryUpgrade__results__header__count--value').text(resultsStart + '-' + resultsEnd + ' of ' + jsonData.count);
                $('.glossaryUpgrade__results__header__count').show();
                $('.glossaryUpgrade__results__export').show();

                // Build the pagination links
                var resultsPerPage = $("#resultsPerPage").val() || 50;
                var pages = Math.ceil(jsonData.count / resultsPerPage);
                var selectedPage = ((resultsStart - 1) / resultsPerPage) + 1;
                var startPage = Math.max(selectedPage - 3, 1);
                var endPage = Math.min(selectedPage + 3, pages);
                if (selectedPage <= 3) endPage = Math.min(endPage + (4 - selectedPage), pages);
                if (selectedPage > pages - 3) startPage = Math.max(pages - 6, 1);
                $('#pagination').empty();
                $('#pagination').data('pages', pages);
                for (var page = startPage; page <= endPage; page++) {
                    var selected = (page - 1) * resultsPerPage == resultsStart - 1;
                    $('#pagination').append('<a href="#' + page + '" class="pagination__link ' + (selected ? 'selected' : '') + '">' + (page < 10 ? "0" + page : page) + '</a>');
                }
                $('.glossaryUpgrade__results__pagination').show();
                $('#pagination .pagination__link').click(function (e) {
                    e.preventDefault();
                    if (!$(this).hasClass('selected')) {
                        $('#page').val($(this).attr('href').replace('#', ''));
                        self.search();
                    }
                });

                // Show the results
                $('.glossaryUpgrade__results__footer').css('visibility', 'visible');
                // $('#resultsPerPage').show();

                $(".glossaryUpgrade__results__list__showdetails__btn").click(function () {

                    if ($(this).parent().parent().find('.more__details').is(':hidden')) {
                        $(this).find('.glossaryUpgrade__results__list__showdetails__icon').css('background-image', 'url(/assets/images/icons/retina/upArrow--purple.png)');
                    }
                    else {
                        $(this).find('.glossaryUpgrade__results__list__showdetails__icon').css('background-image', 'url(/assets/images/icons/retina/downArrow--purple.png)');
                    }

                    $(this).parent().parent().find('.more__details').slideToggle();
                });

                $('input:checkbox[id^="checkbox-term-"]').click(function (e) {
                    if (!$(this).is(':checked')) {
                        $('#select-all').prop('checked', false);
                    }
                });

                // bind add to glossary events.
                addToGlossary.bindEvents();

				$('[data-toggle="popover"]').popover();

				$('[data-toggle="popover"]').on('click', function (e) {
					$('[data-toggle="popover"]').not(this).popover('hide');
				});

                removeFromGlossary.bindEvents();

            } else {
                //$('.glossaryUpgrade__results__header__count--value').text('Your search returned no results.');
                $('.glossaryUpgrade__results__header__count--value').text('');
                $('.glossaryUpgrade__results__footer').css('visibility', 'hidden');
              $('.glossaryUpgrade__results__header__count').hide();
              $('.glossaryUpgrade__results__export').hide();
              $('#resultsList').html('<div class=\"glossaryUpgrade__results__list__item\"><strong>Results:</strong> Your search returned no results.</div>');
               // $('#resultsPerPage').hide();
            }
            $('.glossaryUpgrade__results__header').css('display', 'flex');

            //// Scroll to the top of the results
            if (scrollOption === undefined) {
                setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: $(".glossaryUpgrade__container__row").offset().top - 100
                            },
                            500);
                    },
                    250);
            }
        }
    };
};